
import { Auth } from "interfaces/auth"
import { AuthActionType } from "../action-types/authTypes"
import { Action } from "../actions/authActions"

const initialState: Auth = {
    id: '',
    name: '',
    email: '',
    token: '',
    role: {
        id: '',
        name: ''
    }
}

const reducer = (state: Auth = initialState, action: Action) => {
    switch (action.type) {
        case AuthActionType.LOGIN:
            return {
                ...state,
                token: action.payload
            }
        case AuthActionType.ME:
            return {
                ...state,
                ...action.payload
            }
        default:
            return state
    }
}

export default reducer